import {combineReducers} from 'redux'
import types from 'actions/types'
import {get} from 'lodash'
import quoteDataSource from './quoteDataSource'
import invoiceDataSource from './invoiceDataSource'
import {layoutTypes} from "helpers/layouts"

export const dataSource = (state = layoutTypes.ORDERS, action) => {
  switch (action.type) {
    case types.SALES_UPDATE_SALES_ANALYSIS_DATA_SOURCE_TOGGLE:
      return get(action, 'dataSource', state)
    default:
      return state
  }
}

export const layoutPanels = (state = [], action) => {
  switch (action.type) {
    case types.SALES_UPDATE_SALES_ANALYSIS_DATA_SOURCE_LAYOUT_PANELS:
      return get(action, 'layoutPanels', state).map(panel => {
        return {
          ...panel,
          data: panel.data ? panel.data : [],
        }
      })
    case types.LOAD_LAYOUT_PANEL_ATTEMPT:
      return state.map((panel, index) => {
        return index === action.index
            ? {
              ...panel,
              isLoading: true,
            }
            : panel
      })
    case types.LOAD_LAYOUT_PANEL_SUCCESS:
      return state.map((panel, index) => {
        return index === action.index
            ? {
              ...panel,
              isLoading: false,
              data: action.data,
            }
            : panel
      })
    case types.LOAD_LAYOUT_PANEL_FAILURE:
      return state.map((panel, index) => {
        return index === action.index
            ? {
              ...panel,
              isLoading: true,
              errorMessage: action.message,
            }
            : panel
      })
    case types.SALES_REMOVE_SALES_ANALYSIS_DATA_SOURCE_LAYOUT_PANEL:
      return state.filter((panel, index) => index !== action.index).map((panel, index) => {
        return {
          ...panel,
          sortOrder: index,
        }
      })
    default:
      return state
  }
}

export default combineReducers ({
  dataSource,
  layoutPanels,
  quoteDataSource,
  invoiceDataSource,
})
